/**
 * Adapptio Editor
 *
 * @package editor
 * @copyright 2021-2025 Hexio a.s. <contact@hexio.io> (hexio.io) and contributors.
 * @license Apache-2.0
 *
 * See LICENSE file distributed with this source code for more information.
 */

import { BEM } from "@adapptio/lib-components";
import React, { FC } from "react";
import { Icon, ICON_SIZE } from "../Icon";

export interface IFieldInlineLabelProps {
	icon?: string;
	grow?: boolean;
	className?: string;
}

export const FieldInlineLabel: FC<IFieldInlineLabelProps> = ({ children, icon, grow, className }) => {
	const baseClass = BEM("edt-field-inline-label", undefined, {
		grow: grow
	});

	baseClass.add("edt-field-element");

	if (className) {
		baseClass.add(className);
	}

	return (
		<span className={baseClass.toClassName()}>
			{icon ? <Icon name={icon} size={ICON_SIZE.SMALL} /> : null}
			{children}
		</span>
	);
};
